module.exports = __webpack_public_path__ + "static/media/priority_high.49c8e9f6.svg";